import { ModKeys } from "@intelligems/ig-types/fe-only/personalizations";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  addVariationMod,
  setModActivated,
} from "@src/store/slices/experienceInfoState";

/**
 * Turns a mod on, the same way the manual editor does: experiments add the
 * mod per variation (`activatedVariationMods`); personalizations keep one
 * flat list (`activatedModArr`) and `setModActivated` is an on/off switch, so
 * it's only dispatched when the mod isn't already on — dispatching it again
 * would toggle it back off.
 */
export const activateMod = createAsyncThunk<
  void,
  { mod: ModKeys; variationId: string }
>(
  "checkoutBlocks/activateMod",
  ({ mod, variationId }, { dispatch, getState }) => {
    if (getState().experience.experience?.category === "experiment") {
      dispatch(addVariationMod({ variationId, mod }));
    } else if (!getState().experienceInfoState.activatedModArr.includes(mod)) {
      dispatch(setModActivated({ key: mod }));
    }
  }
);
